<template>
  <div>
    <b-navbar type="light" class="navbar-backstage">
      <b-navbar-brand href="#">
        <img
          src="@/assets/image/quartercar-logo-small-green.svg"
          class="d-inline-block align-center"
          alt="logo"
          id="logoImage"
        />
        <small class="pl-4 d-none d-sm-inline-block"
          >{{ user ? user.company.company_name : "廠商" }}後台</small
        >
      </b-navbar-brand>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <li class="nav-item">
            <b-button v-b-toggle.notifySidebar variant="link" class="nav-link">
              <b-iconstack>
                <b-icon
                  stacked
                  icon="bell-fill"
                  variant="light"
                  scale="0.8"
                ></b-icon>
                <b-icon
                  v-if="has_notify"
                  stacked
                  icon="dot"
                  variant="danger"
                  shift-h="4"
                  shift-v="4"
                  scale="2"
                ></b-icon>
              </b-iconstack>
            </b-button>
          </li>
          <b-nav-item-dropdown right no-caret>
            <template v-slot:button-content>
              <b-icon icon="person-fill" variant="light"></b-icon>
              <span class="text-white px-2 d-none d-md-inline"
                >嗨！ {{ user ? user.name : "" }}</span
              >
            </template>
            <b-dropdown-text class="d-sm-none" style="width: 240px;"
              >{{ user ? user.company.company_name : "廠商" }}後台 -
              {{ user ? user.name : "" }}</b-dropdown-text
            >
            <b-dropdown-divider class="d-sm-none"></b-dropdown-divider>
            <b-dropdown-item href="#" @click="signOut">登出</b-dropdown-item>
          </b-nav-item-dropdown>
          <li class="nav-item collapsed d-md-none d-inline-block">
            <a href="#sidebar" v-b-toggle class="nav-link">
              <b-icon icon="list" variant="light"></b-icon>
            </a>
          </li>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-sidebar
      id="notifySidebar"
      shadow
      z-index="1000"
      right
      backdrop
      title="通知中心"
      class="sidebar notify"
      header-class="flex-row-reverse border-bottom"
      v-if="notify_list"
    >
      <div class="p-3 border-bottom">
        <small class="mr-2">推播授權狀態</small>
        <small class="d-inline-block">{{ notificationStatus }}</small>
      </div>
      <nav v-if="notify_list.length">
        <ul class="nav flex-column">
          <li
            class="nav-item border-bottom"
            v-for="item in notify_list"
            :key="item.uuid"
          >
            <a
              class="nav-link py-2"
              :class="{ read: !item.not_read }"
              href="#"
              @click.prevent="isRead(item.uuid, item.message)"
            >
              <div class="notify-time">
                {{ format(item.created_at, "yyyy-MM-dd hh:mm") }}
              </div>
              <div class="notify-message">{{ item.message }}</div>
            </a>
          </li>
        </ul>
      </nav>
      <div v-else class="p-3">目前尚無通知</div>
      <template #footer>
        <div class="text-center p-2" v-if="notify_list.length">
          <b-button variant="cms_main" squared type="button" @click="allRead"
            ><b-icon icon="check2" class="mr-2"></b-icon>全部標示已讀</b-button
          >
        </div>
      </template>
    </b-sidebar>
    <b-toast
      id="notify-toast"
      title="通知中心"
      toaster="b-toaster-top-center"
      solid
      :appendToast="false"
      variant="cms_main"
    >
      <a v-b-toggle href="#notifySidebar" @click.prevent>
        您有{{ has_notify }}筆新的通知，點擊我開啟列表
      </a>
    </b-toast>
  </div>
</template>

<style lang="scss" scoped>
.navbar-backstage {
  &::after {
    background-color: $cms_main;
  }
  &::before {
    border-color: transparent transparent $cms_main transparent;
  }
}
.notify {
  ::v-deep .close {
    margin-left: auto;
    margin-right: 0 !important;
  }
  ::v-deep header {
    font-size: 20px;
  }
  ::v-deep .nav-link {
    background-color: #d7eae3;
    &.read {
      background-color: #fff;
    }
  }
  &-time {
    font-size: 12px;
    color: #888;
  }
  &-message {
    font-size: 14px;
    color: #333;
    font-weight: initial;
  }
}
#notify-toast {
  a {
    color: #004029;
  }
}
</style>

<script>
import "@/assets/js/dateFormat.js";
import { LoginCms, Notify } from "@/assets/api/cms.js";
import { Toast } from "@/plugins/sweetalert2.js";
// import "firebase/messaging";

export default {
  name: "Navbar",
  props: ["token", "isMobile"],
  data() {
    return {
      has_notify: null,
      notify_list: null,
      user: null,
      notificationStatus: ""
    };
  },
  watch: {
    has_notify(val) {
      if (val && !this.isMobile) {
        this.$bvToast.show("notify-toast");
      }
    }
  },
  created() {
    LoginCms.user(this.token)
      .then(res => {
        if (res.status == 200) {
          this.user = res.data;
        } else {
          Toast.fire({
            icon: "error",
            title: "無法取得會員資料",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
    Notify.get(this.token)
      .then(res => {
        if (res.status == 200) {
          this.has_notify = res.data.count;
          this.notify_list = res.data.data.data.reverse();
        } else {
          Toast.fire({
            icon: "error",
            title: "無法取得通知訊息",
            text: res.data.error
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  },
  methods: {
    format(date, formatText) {
      return new Date(date).format(formatText);
    },
    signOut() {
      localStorage.removeItem("cms-api_token");
      localStorage.removeItem("isAdmin");
      this.$router.push({ name: "廠商後台登入" });
    },
    getOrderNum(text) {
      const slice = text.indexOf(": ", 0);
      return text.slice(slice + 2, -1);
    },
    isRead(uuid, message) {
      Notify.read(uuid, this.token).then(() => {
        Notify.get(this.token).then(data => {
          this.has_notify = data.data.count;
          this.notify_list = data.data.data.data;
        });
        this.$router.push({
          name: "訂單管理",
          query: { search: this.getOrderNum(message) }
        });
      });
    },
    allRead() {
      this.notify_list.forEach(item => {
        if (!item.not_read) return;
        Notify.read(item.uuid, this.token);
      });
      this.$root.$emit("bv::toggle::collapse", "notifySidebar");
      setTimeout(() => {
        Notify.get(this.token).then(data => {
          this.has_notify = data.data.count;
          this.notify_list = data.data.data.data;
        });
      }, 500);
    },
    registeFCM() {
      this.$messaging
        .requestPermission()
        .then(() => {
          // 先判斷cookies有沒有token，沒有再取token
          var ckv =
            document.cookie.replace(
              /(?:(?:^|.*;\\s*)augustusWsPush\s*=\s*([^;]*).*$)|^.*$/,
              "$1"
            ) || null;
          if (ckv === null) {
            // 拿到token，firebase-messaging-sw.js 就會存 Service Workers 裡

            this.$messaging.getToken().then(currentToken => {
              Notify.saveToken(
                {
                  token: currentToken
                },
                this.token
              ).then(res => {
                console.log(res);
              });

              // token存至firebase
              // var id = currentToken.split(":")[0];
              // this.$database
              //   .ref("pushUsers/" + id)
              //   .set({ token: currentToken });

              // token存至cookies
              document.cookie = "augustusWsPush=" + currentToken;
            });
          }
          // cookies 已存在，從 cookies 取出後傳至 firebase
          else {
            // var id = ckv.split(":")[0];
            // this.$database.ref("pushUsers/" + id).set({ token: ckv });
            Notify.saveToken(
              {
                token: ckv
              },
              this.token
            ).then(res => {
              console.log(res);
            });
          }
          console.log("Notification permission granted.");
          this.notificationPermission();
        })
        .catch(err => {
          console.log("Unable to get permission to notify.", err);
          this.notificationPermission();
        });
    },
    notificationPermission() {
      if (!Notification) return;
      switch (Notification.permission) {
        case "default":
          this.notificationStatus = "尚未給予任何權限，您將不會收到推播消息";
          Notification.requestPermission();
          break;
        case "granted":
          this.notificationStatus = "允許通知";
          break;
        case "denied":
          this.notificationStatus = "拒絕通知，您將不會收到推播消息";
          break;
        default:
          break;
      }
    }
  },
  mounted() {
    this.registeFCM();
    this.$messaging.onMessage(payload => {
      const notification = payload.notification || payload.data;
      const noteTitle = notification.title;
      const noteOptions = {
        body: notification.body,
        icon: "/favicon-96.png",
        badge: "/favicon-96.png"
      };
      new Notification(noteTitle, noteOptions);
      Notification.onclick = function(event) {
        event.preventDefault();
        window.open("/order", "_blank");
      };
    });
  }
};
</script>
